<template>
    <page :busy="busy" :tabs="tabs">
        <router-view @busy="handleBusy"></router-view>
    </page>
</template>

<script>
import Page from '../generic/page/page.vue';

export default {
    name: 'Partner',
    components: {
        Page,
    },
    mounted() {
        if (this.$route.path === '/app/partner/') {
            const tab = this.getActiveTab();
            if (tab) {
                this.$router.push(`/app/partner/${tab}/`);
            } else {
                this.vrboRedirect();
            }
        }
    },
    computed: {
        tabs() {
            const tabs = [];
            tabs.push({
                title: `VRBO`,
                route: `/app/partner/vrbo/`,
                active: this.$route.path === `/app/partner/vrbo/`,
                callback: this.setVRBOActiveTab,
            });
            tabs.push({
                title: `NextPax`,
                route: `/app/partner/nextpax/`,
                active: this.$route.path.includes(`/app/partner/nextpax/`),
                callback: this.setNextpaxActiveTab,
            });
            tabs.push({
                title: `Airbnb`,
                route: `/app/partner/airbnb/`,
                active: this.$route.path === `/app/partner/airbnb/`,
                callback: this.setAirbnbActiveTab,
            });
            if (this.$route.path == `/app/partner/reviews/`) {
                tabs.push({
                    title: `Reviews`,
                    route: `/app/partner/reviews/`,
                    active: this.$route.path === `/app/partner/reviews/`,
                    callback: () => {},
                });
            };
            return tabs;
        },
    },
    data() {
        return {
            busy: false,
            localStorageActiveTabKey: 'partnerActiveTab',
        };
    },
    methods: {
        handleBusy(busy) {
            this.busy = busy;
        },
        getActiveTab() {
            const valid = [
                'vrbo',
                'nextpax',
                'airbnb',
            ];
            const tab = localStorage.getItem(this.localStorageActiveTabKey);
            if (valid.includes(tab)) {
                return tab;
            }
            return null;
        },
        setVRBOActiveTab() {
            localStorage.setItem(this.localStorageActiveTabKey, 'vrbo');
        },
        setNextpaxActiveTab() {
            localStorage.setItem(this.localStorageActiveTabKey, 'nextpax');
        },
        setAirbnbActiveTab() {
            localStorage.setItem(this.localStorageActiveTabKey, 'airbnb');
        },
        vrboRedirect() {
            this.$router.push('/app/partner/vrbo/');
            this.setVRBOActiveTab();
        },
    },
};
</script>